import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { BulkTripPriceChangeItemRead } from 'src/common/external/bambi-api/bambiApi';
import { formatAddress } from 'src/common/formatAddress';
import { formatPriceCell } from 'src/common/formatPriceCell';

const columnHelper = createColumnHelper<BulkTripPriceChangeItemRead>();

const rowSelectionColumnDef = columnHelper.display({
  id: 'selection',
  header: () => <div data-testid="row-selection-column" />,
  enableHiding: false,
  meta: {
    enableHeaderMenu: false,
  },
  cell: ({ row }) => {
    return (
      <input
        data-testid={`row-selection-control-${row.original.id}`}
        type="checkbox"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
      />
    );
  },
});

const passengerColumnDef = columnHelper.accessor('passenger', {
  header: 'Passenger',
  cell: (props) => {
    return <span>{props.row.original.passenger}</span>;
  },
});

const scheduledPickupAtColumnDef = columnHelper.accessor(
  'scheduled_pickup_at',
  {
    header: 'Scheduled Pickup At',
    cell: (props) => {
      return (
        <span>
          {DateTime.fromISO(
            props.row.original.scheduled_pickup_at
          ).toLocaleString({
            weekday: 'short',
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          }) +
            ' ' +
            DateTime.fromISO(props.row.original.scheduled_pickup_at).toFormat(
              't'
            )}
        </span>
      );
    },
  }
);

const pickupAddressColumnDef = columnHelper.accessor('pickup', {
  header: 'Pickup Address',
  cell: ({ row }) => formatAddress(row.original.pickup),
});

const dropoffAddressColumnDef = columnHelper.accessor('dropoff', {
  header: 'Dropoff Address',
  cell: ({ row }) => formatAddress(row.original.dropoff),
});

const payerColumnDef = columnHelper.accessor('payer', {
  header: 'Payer',
  cell: (props) => props.row.original.payer,
});

const inputPriceCentsColumnDef = columnHelper.accessor('input_price_cents', {
  header: 'Current Price',
  cell: (props) => {
    const { input_price_cents } = props.row.original;
    const formattedPrice = formatPriceCell(input_price_cents);
    return <span className="text-red-500">{formattedPrice}</span>;
  },
});

const newPriceCentsColumnDef = columnHelper.accessor('new_price_cents', {
  header: 'New Price',
  cell: (props) => {
    const { new_price_cents } = props.row.original;
    const formattedPrice = formatPriceCell(new_price_cents);
    return <span className="text-green-500">{formattedPrice}</span>;
  },
});

export const bulkPriceTripNoPricingSchemeResultsColumns: ColumnDef<
  BulkTripPriceChangeItemRead,
  any
>[] = [
  passengerColumnDef,
  scheduledPickupAtColumnDef,
  pickupAddressColumnDef,
  dropoffAddressColumnDef,
  payerColumnDef,
];

export const bulkPriceTripResultsColumns: ColumnDef<
  BulkTripPriceChangeItemRead,
  any
>[] = [
  rowSelectionColumnDef,
  passengerColumnDef,
  scheduledPickupAtColumnDef,
  pickupAddressColumnDef,
  dropoffAddressColumnDef,
  payerColumnDef,
  inputPriceCentsColumnDef,
  newPriceCentsColumnDef,
];
